const isDev = process.env.NODE_ENV === 'development';

const overrideBase = process.env.REACT_APP_API_BASE_URL?.trim();
const API_BASE_URL = overrideBase || (isDev ? '' : 'https://backend.chassisbot-dev.dcli.com');

const RETRIEVE_PATH = '/retrieve';
const HEALTH_PATH = '/health';
const INGEST_PATH = '/ingest';
const API_TIMEOUT_MS = 120000;

const API_CONFIG = {
  BASE_URL: API_BASE_URL,
  ENDPOINTS: {
    RETRIEVE: RETRIEVE_PATH,
    INGEST: INGEST_PATH,
    HEALTH: HEALTH_PATH,
    GET_CONVERSATION: '/get_conversation' 
  },
  TIMEOUT: API_TIMEOUT_MS
};

export default API_CONFIG;
export { API_BASE_URL, RETRIEVE_PATH, HEALTH_PATH, INGEST_PATH, API_TIMEOUT_MS };
